module.exports = __webpack_public_path__ + "static/img/ent-detail-32.309c862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-32.jpg
// module id = H2MV
// module chunks = 52